module.exports = __webpack_public_path__ + "img/img17.3250531c.svg";